import * as Cookies from 'js-cookie';

import { AppInsightsAnalytics } from '../AppInsight';
import { AnalyticsEventsPair }    from './AnalyticsEventBuilder';
import { HomeAnalytics }     from './HomeAnalytics';
import { GamesAnalytics }    from './GamesAnalytics';
import { GeneralAnalytics }  from './GeneralAnalytics';
import { GoogleAnalyticsService }   from '../GoogleAnalyticsService';
import { isServer }          from '../../../utils';
import { KeysEnum }          from '../../models/Enums';
import { UrlService }        from '../UrlService';
import { DetectDevice, DetectDeviceUAParser } from '../DeviceDetector';
import { LocalStorageService } from '../LocalStorage';
import { ADO_BUILD_VERSION }    from '../../../version';

const trimUndefinedProps = (obj) => Object.keys(obj).forEach((key => obj[key] === undefined ? delete obj[key] : null));
const arenaVersion = 'AARP';
const buildVersion = ADO_BUILD_VERSION;

class AnalyticsService {
    general = new GeneralAnalytics();
    home = new HomeAnalytics();
    games = new GamesAnalytics();
    userType: 'returning' | 'new';

    init() {
        AppInsightsAnalytics.init();
        GoogleAnalyticsService.init();
        this.handleUserType();
    }

    trackPageView(historyNavigation?: boolean) {
        const utmInfo = UrlService.getUtmInfo();

        const data = {
            ...utmInfo,
            pageType: UrlService.getPageType(),
            deviceType: DetectDevice(),
            deviceType2: DetectDeviceUAParser(),
            urlReferrer: historyNavigation ? undefined : UrlService.getReferrerIfOuter(),
            arenaVersion,
            buildVersion
        };

        trimUndefinedProps(data);
        AppInsightsAnalytics.trackPageView(data);
        GoogleAnalyticsService.trackPageView();
    }

    trackEvent(event: AnalyticsEventsPair) {
        if (!isServer) {
            if (event.ai) {
                trimUndefinedProps(event.ai.data);
                AppInsightsAnalytics.trackEvent(event.ai.name, event.ai.data);
            }
            if (event.ga) {
                GoogleAnalyticsService.trackEvent(event.ga.data);
            }
        }
    }

    historyNavigationCalculate() {
        let aiSessionId;
        const aiSessionCookieValue = Cookies.get(KeysEnum.aiSessionCookie);
        if (aiSessionCookieValue) {
            aiSessionId = aiSessionCookieValue.split('|')[0];
        } else {
            LocalStorageService.setItem(KeysEnum.arkAiSessionLocalStorage, 'default');
            return false;
        }

        let aiSessionIdPrev = LocalStorageService.getItem(KeysEnum.arkAiSessionLocalStorage);
        if (aiSessionIdPrev === null || aiSessionIdPrev === 'default') {
            LocalStorageService.setItem(KeysEnum.arkAiSessionLocalStorage, aiSessionId);
            aiSessionIdPrev = aiSessionId;
        }

        if (aiSessionIdPrev && aiSessionId === aiSessionIdPrev  ) {
            return true;
        }

        LocalStorageService.setItem(KeysEnum.arkAiSessionLocalStorage, aiSessionId);
        return false;
    }

    private handleUserType() {
        const firstVisit = Cookies.get(KeysEnum.arkFirstVisitAt) || new Date().toISOString();
        const cookieLifeTime = { expires: 3600 * 24 * 365, path: '/', secure: true};

        Cookies.set(KeysEnum.arkFirstVisitAt, firstVisit, cookieLifeTime);
        
        const sessionDurationHours = (Date.now() - Date.parse(firstVisit)) / 1000 / 60 / 60;
        this.userType = sessionDurationHours >= 1 ? 'returning' : 'new';

        Cookies.set(KeysEnum.arkUserType, this.userType, cookieLifeTime);
    }
}

export const Analytics = new AnalyticsService();
